function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Space, Alert, notification } from 'antd';
import ImgCrop from 'antd-img-crop';
import { PlusCircleFill } from "react-bootstrap-icons";
import axios from 'axios';
import Common from "../../components/includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddTicket = function AddTicket(_ref) {
  var handler = _ref.handler,
    event = _ref.event;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pmList = _useState6[0],
    setPmList = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    ticketPrice = _useState8[0],
    setTicketPrice = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    totalAmount = _useState10[0],
    setTotalAmount = _useState10[1];
  var _useState11 = useState(1),
    _useState12 = _slicedToArray(_useState11, 2),
    ticketQuantity = _useState12[0],
    setTicketQuantity = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    apList = _useState14[0],
    setApList = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    apOptions = _useState16[0],
    setApOptions = _useState16[1];
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    //formData.append('name', values.name);
    //formData.append('amount', totalAmount);
    //formData.append('email', values.email); 
    //formData.append('mobile', values.mobile);
    //formData.append('payment_gateway_id', values.payment_gateway_id);
    formData.append('event_id', event.id);
    formData.append('price_schema_item_id', values.plan);
    formData.append('quantity', values.quantity);
    formData.append('user_id', Common.currentUser == null || Common.currentUser == 'undefined' ? 0 : Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addtickets', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  var handleQuantityChange = function handleQuantityChange(v) {
    setTicketQuantity(v);
    setTotalAmount(ticketPrice * v);
  };
  var handlePriceChange = function handlePriceChange(v) {
    var ap = apList.filter(function (i) {
      return i.id == v;
    })[0];
    setTicketPrice(ap.price);
    setTotalAmount(ap.price * ticketQuantity);
  };
  useEffect(function () {
    if (event.price_schema_items.length > 0) {
      setTicketPrice(event.price_schema_items[0].price);
      setTotalAmount(event.price_schema_items[0].price * ticketQuantity);
    }
    axios.all([axios.get(Common.baseApiUrl + 'getpgs'), axios.get(Common.baseApiUrl + 'geteventplans/' + event.id.toString())]).then(function (response) {
      if (response[0].data.status == 200) {
        setPmList([]);
        response[0].data.pgs.forEach(function (pg) {
          setPmList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 3,
                  ms: 3,
                  xs: 3,
                  children: /*#__PURE__*/_jsx("img", {
                    src: "drawables/" + pg.logo
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 3,
                  md: 3,
                  ms: 3,
                  xs: 3,
                  children: /*#__PURE__*/_jsx("b", {
                    children: pg.label
                  })
                })]
              })
            }]);
          });
        });
        if (response[0].data.pgs.length > 0) form.setFieldsValue({
          payment_gateway_id: response[0].data.pgs[0].id
        });
      }
      if (response[1].data.status == 200) {
        setApList([]);
        response[1].data.plans.forEach(function (p) {
          setApOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: p.id,
              label: "".concat(p.label, "(").concat(p.price.toLocaleString("Fr"), ")")
            }]);
          });
        });
        if (response[1].data.plans.length > 0) form.setFieldsValue({
          plan: response[1].data.plans[0].id
        });
        setApList(response[1].data.plans);
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
    if (Common.currentUser != 'undefined' && Common.currentUser != null) form.setFieldsValue({
      name: "".concat(Common.currentUser.firstname, " ").concat(Common.currentUser.lastname),
      email: Common.currentUser.email,
      mobile: Common.currentUser.mobile
    });
    form.setFieldsValue({
      quantity: 1
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      size: "middle",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Emplacement",
        name: "plan",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Select, {
          options: apOptions,
          onChange: handlePriceChange,
          style: {
            width: "200px"
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Nombre de Ticket",
        name: "quantity",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          onChange: handleQuantityChange,
          style: {
            width: "200px"
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: pmList.length == 0,
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "GENERER"
          })
        })
      })]
    })
  });
};
export default AddTicket;